import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../components/layout/index.vue";
import Home from "@/views/Home/Home.vue";
import AboutUs from "@/views/business/AboutUs.vue";
import login from "@/views/Login/login.vue";
import loginRetailer from "@/views/Login/loginRetailer.vue";
import paySteps from "@/views/business/pay/paySteps.vue";
import Buy from "@/views/business/pay/Buy.vue";
import BuyMenu from "@/views/business/pay/BuyMenu.vue";
import AllProducts from "@/views/business/products/AllProducts.vue";
import Productsintro from "@/views/business/products/ProductIntro.vue";
import Cart from "@/views/business/pay/Cart.vue";
import Service from "@/views/business/service/Service.vue";
import Communicate from "@/views/business/service/Communicate/Communicate.vue";
import ContactUs from "@/views/business/service/ContactUs/ContactUs";
import PersonalCenter from "@/views/business/PersonalCenter/PersonalCenter";
import SoftwareSupportDetail from "@/views/business/service/SoftwareSupport/SoftwareSupportDetail";
import SoftwareSupport from "@/views/business/service/SoftwareSupport/SoftwareSupport";
import AccountSupportDetail from "@/views/business/service/AccountSupport/AccountSupportDetail";
import AccountSupportContent from "@/views/business/service/AccountSupport/AccountSupportContent";
import AccountSupport from "@/views/business/service/AccountSupport/AccountSupport";
import NotFount from "@/views/business/defaultPage/NotFount";
import NetworkAnomaly from "@/views/business/defaultPage/NetworkAnomaly";
import NotOpen from "@/views/business/defaultPage/NotOpen";
import SearchNone from "@/views/business/defaultPage/SearchNone";
import logincopy from "@/views/Login/logincopy";
import Retailer from "@/views/business/Retailer/index";

import { getToken, setToken, removeToken } from "@/utils/auth";
import store from "../store/index";
import NoticeDetail from "@/views/business/notice/NoticeDetail.vue";
import FreeSoft from "@/views/business/products/FreeSoft.vue";
import GuochanDownload from "@/views/business/products/GuochanDownload.vue";
import Feedback from "@/views/business/products/Feedback.vue";

import { PayFun } from "@/assets/API/pay"; // 确保引入 PayFun

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

// ============ 设备检测函数 ============
function isMobileDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // 注意兼容华为鸿蒙：HarmonyOS/OpenHarmony 的 UA 中不含 Android/iPhone 关键字
  const mobileRegex = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|HarmonyOS|OpenHarmony)/i;
  return mobileRegex.test(userAgent);
}

// ============ PC端路由 ============
const routePC = [
  {
    path: "/",
    name: "Layout",
    redirect: "Home",
    component: Layout,
    children: [
      {
        path: "Home",
        name: "首页",
        component: Home,
      },
      {
        path: "AboutUs",
        name: "关于我们",
        component: AboutUs,
      },
      {
        path: "/login",
        name: "Login",
        component: login,
      },
      {
        path: "/loginRetailer",
        name: "loginRetailer",
        component: loginRetailer,
      },
      {
        path: "/logincopy",
        name: "logincopy",
        component: logincopy,
      },
      {
        path: "/paystep",
        name: "支付流程",
        component: paySteps,
      },
      {
        path: "/Buy",
        name: "订阅购买",
        component: Buy,
      },
      {
        path: "/BuyMenu",
        name: "套餐选择",
        component: BuyMenu,
      },
      {
        path: "/cart",
        name: "购物车",
        component: Cart,
      },
      {
        path: "/AllProducts",
        name: "全部产品",
        component: AllProducts,
      },
      {
        path: "/freeSoft",
        name: "免费软件",
        component: FreeSoft,
      },
      {
        path: "/products/guochan-download",
        name: "国产信创下载",
        component: GuochanDownload,
      },
      {
        path: "/feedback",
        name: "意见反馈",
        component: Feedback,
      },
      {
        path: "/Productsintro",
        name: "产品介绍",
        component: Productsintro,
      },
      {
        path: "/Service",
        name: "服务与支持",
        component: Service,
      },
      {
        path: "/Communicate",
        name: "问题交流",
        component: Communicate,
      },
      {
        path: "/addQuestionDetail",
        component: () =>
          import("@/views/business/service/Communicate/addQuestionDetail.vue"),
      },
      {
        path: "/AddForumPost",
        component: () =>
          import("@/views/business/service/Communicate/AddForum.vue"),
      },
      {
        path: "/ContactUs",
        name: "联系我们",
        component: ContactUs,
      },
      {
        path: "/Retailer",
        name: "分销商",
        component: Retailer,
      },
      {
        path: "/PersonalCenter",
        name: "我的中心",
        component: PersonalCenter,
      },
      {
        path: "/NoticeDetail",
        name: "通知公告详情",
        component: NoticeDetail,
      },
      {
        path: "/SoftwareSupportDetail",
        name: "软件支持详情",
        component: SoftwareSupportDetail,
      },
      {
        path: "/SoftwareSupport",
        name: "软件支持",
        component: SoftwareSupport,
      },
      {
        path: "/AccountSupportDetail",
        name: "账号支持详情",
        component: AccountSupportDetail,
      },
      {
        path: "/AccountSupportContent",
        name: "账号支持详情内容",
        component: AccountSupportContent,
      },
      {
        path: "/AccountSupport",
        name: "账号支持",
        component: AccountSupport,
      },
      {
        path: "/404",
        name: "404",
        component: NotFount,
      },
      {
        path: "/NetworkAnomaly",
        name: "网络异常",
        component: NetworkAnomaly,
      },
      {
        path: "/NotOpen",
        name: "功能未开放",
        component: NotOpen,
      },
      {
        path: "/SearchNone",
        name: "未搜到结果",
        component: SearchNone,
      },
    ],
  },
];

// ============ 移动端 H5 路由 ============
const mobileRoutes = [
  {
    path: "/mobile",
    component: () => import("@/views/mobile/MobileLayout.vue"),
    redirect: "/mobile/home",
    children: [
      {
        path: "home",
        name: "MobileHome",
        component: () => import("@/views/mobile/MobileHome.vue"),
        meta: { title: "首页", keepAlive: true },
      },
      {
        path: "search",
        name: "search",
        component: () => import("@/views/mobile/MobileSearch.vue"),
        meta: { title: "首页", keepAlive: true },
      },
      {
        path: "service/detail",
        name: "MobileServiceDetail",
        component: () => import("@/views/mobile/MobileServiceDetail.vue"),
        meta: { title: "详情" },
      },
      {
        path: "notice/detail",
        name: "MobileNoticeDetail",
        component: () => import("@/views/mobile/MobileNoticeDetail.vue"),
        meta: { title: "通知公告" },
      },
      {
        path: "service/list",
        name: "MobileServiceList",
        component: () => import("@/views/mobile/MobileServiceList.vue"),
        meta: { title: "服务支持" },
      },
      {
        path: "login",
        name: "MobileLogin",
        component: () => import("@/views/mobile/MobileLogin.vue"),
        meta: { title: "登录" },
      },
      {
        path: "products",
        name: "MobileProducts",
        component: () => import("@/views/mobile/MobileProducts.vue"),
        meta: { title: "产品", keepAlive: true },
      },
      {
        path: "product/detail",
        name: "MobileProductDetail",
        component: () => import("@/views/mobile/MobileProductDetail.vue"),
        meta: { title: "产品详情" },
      },
      {
        path: "product/Freedetail",
        name: "MobileFreeProductDetail",
        component: () => import("@/views/mobile/MobileFreeProductDetail.vue"),
        meta: { title: "产品详情" },
      },
      {
        path: '/mobile/mine',
        name: 'MobileMine',
        component: () => import('@/views/mobile/MobileMine.vue'),
        meta: { title: '我的' }
      },
      {
        path: '/mobile/subscribe-guide',
        name: 'MobileSubscribeGuide',
        component: () => import('@/views/mobile/MobileSubscribeGuide.vue'),
        meta: { title: '订阅指南' }
      },
      {
        path: '/mobile/subscribe-guide/detail',
        name: 'MobileSubscribeGuideDetail',
        component: () => import('@/views/mobile/MobileSubscribeGuideDetail.vue'),
        meta: { title: '指南详情' }
      },
      {
        path: '/mobile/profile',
        name: 'MobileProfile',
        component: () => import('@/views/mobile/MobileProfile.vue'),
        meta: { title: '个人信息' }
      },
      {
        path: '/mobile/orders',
        name: 'MobileOrders',
        component: () => import('@/views/mobile/MobileOrders.vue'),
        meta: { title: '订单管理' }
      },
      {
        path: '/mobile/license',
        name: 'MobileLicense',
        component: () => import('@/views/mobile/MobileLicense.vue'),
        meta: { title: '许可证申请' }
      },
      {
        path: '/mobile/invoice-profile',
        name: 'MobileInvoiceProfile',
        component: () => import('@/views/mobile/MobileInvoiceProfile.vue'),
        meta: { title: '开票信息维护' }
      },
      {
        path: '/mobile/cart',
        name: 'MobileCart',
        component: () => import('@/views/mobile/MobileCart.vue'),
        meta: { title: '购物车' }
      },
      {
        path: '/mobile/checkout',
        name: 'MobileCheckout',
        component: () => import('@/views/mobile/MobileCheckout.vue'),
        meta: { title: '确认订单' }
      }, 
      {
        path: '/mobile/pay/success',
        name: 'MobilePaySuccess',
        component: () => import('@/views/mobile/MobilePaySuccess.vue'),
        meta: {
          title: '支付成功'
        }
      },
      {
        path: "/mobile/login",
        name: "MobileLogin",
        component: () => import("@/views/mobile/MobileLogin.vue"),
        meta: { title: "登录" }
      },
    ],
  },
  // 保留原有的移动端申请相关路由
  // 原线下申请入口 /apply 统一跳转到 ApplyLicense2（参数 id/pid/dogID 全部兼容透传）
  {
    path: "/apply",
    name: "apply",
    redirect: (to) => ({ path: "/ApplyLicense2", query: to.query }),
  },
  {
    path: "/applylistm",
    name: "applylistm",
    component: () => import("@/views/Home/ApplyListM.vue"),
  },
  {
    path: "/create",
    name: "HomeM",
    component: () => import("@/views/Home/HomeM.vue"),
  },
  {
    path: "/applyTrial",
    name: "applyTrial",
    component: () => import("@/views/Home/HomeM.vue"),
  },
  {
    path: "/ApplyList",
    name: "ApplyList",
    component: () => import("@/views/business/mobileLicense/ApplyList.vue"),
  },
  {
    path: "/ApplyHome",
    name: "ApplyHome",
    component: () => import("@/views/business/mobileLicense/ApplyHome.vue"),
  },
  {
    path: "/ApplyLicense2",
    name: "ApplyLicense2",
    component: () =>
      import("@/views/business/mobileLicense/CustomerOfflineLicenseApply.vue"),
    meta: { title: "线下许可证申请" },
  },
  {
    path: "/ApplyLicenseNoDog",
    name: "ApplyLicenseNoDog",
    component: () => import("@/views/business/mobileLicense/NoDogSpecialLicenseApply.vue"),
    meta: { title: "无加密狗许可申请" },
  },
  {
    path: "/ApplyLicenseNoDogList",
    name: "ApplyLicenseNoDogList",
    component: () => import("@/views/business/mobileLicense/NoDogSpecialLicenseList.vue"),
    meta: { title: "无加密狗许可证查询" },
  },
];

// ============ PC 路径到移动端路径的映射 ============
const pcToMobilePathMap = {
  "/": "/mobile/home",
  "/Home": "/mobile/home",
  "/login": "/mobile/login",
  "/AllProducts": "/mobile/products",
  "/freeSoft": "/mobile/products",
  "/Buy": "/mobile/buy",
  "/BuyMenu": "/mobile/buy",
  "/Service": "/mobile/service",
  "/AboutUs": "/mobile/about",
  "/ContactUs": "/mobile/about",
  "/Productsintro": "/mobile/product/detail",
  "/PersonalCenter": "/mobile/mine",
};

// ============ 移动端路径到 PC 路径的映射 ============
const mobileToPcPathMap = {
  "/mobile": "/",
  "/mobile/home": "/",
  "/mobile/login": "/login",
  "/mobile/products": "/AllProducts",
  "/mobile/product/detail": "/Productsintro",
  "/mobile/buy": "/Buy",
  "/mobile/service": "/Service",
  "/mobile/about": "/AboutUs",
};

// ============ 需要保留在移动端的特殊路径（不重定向） ============
const mobileSpecialPaths = [
  "/apply",
  "/applylistm",
  "/create",
  "/applyTrial",
  "/ApplyList",
  "/ApplyHome",
  "/ApplyLicense2",
  "/ApplyLicenseNoDog",
  "/ApplyLicenseNoDogList",
];

// ============ 根据设备类型选择路由 ============
let routes = [];
const isMobile = isMobileDevice();

if (isMobile) {
  // 移动端：使用移动端路由 + PC路由（用于重定向）
  routes = [...mobileRoutes, ...routePC];
  console.log("移动端");
} else {
  // PC端：使用PC路由 + 移动端路由（用于重定向）
  routes = [...routePC, ...mobileRoutes];
  console.log("电脑端");
}

// 添加 404 通配路由
routes.push({
  path: "*",
  redirect: isMobile ? "/mobile/home" : "/",
});
const publicPath = process.env.VUE_APP_RESOURCE_URL;
const createRouter = () =>
  new VueRouter({
    mode: "history",
    base: publicPath,
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      }
      return { x: 0, y: 0 };
    },
  });

// 获取用户信息缓存
Storage.prototype.getExpire = (key) => {
  let val = localStorage.getItem(key);
  if (!val) {
    return val;
  }
  val = JSON.parse(val);
  if (Date.now() - val.time > val.expire) {
    localStorage.removeItem(key);
    return null;
  }
  return val.data;
};

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

const router = createRouter();

// ============ 路由守卫 ============
router.beforeEach((to, from, next) => {
  const mobile = isMobileDevice();
  const isMobilePath = to.path.startsWith("/mobile");
  const isSpecialMobilePath = mobileSpecialPaths.some((p) =>
    to.path.startsWith(p)
  );

  // 1. 处理支付回调
  if (to.query && to.query.out_trade_no) {
    let out_trade_no = to.query.out_trade_no;
    const str = {
      OutTradeNo: out_trade_no,
      phone: localStorage.getExpire("token"),
    };
    PayFun(str).then((res) => {
      if (res.data.code === 200) {
        return next("/user/orderManagement");
      }
    });
    return;
  }

  // 2. 移动设备访问 PC 页面，重定向到移动端
  if (mobile && !isMobilePath && !isSpecialMobilePath) {
    const mobilePath = pcToMobilePathMap[to.path];
    if (mobilePath) {
      console.log(`移动端重定向: ${to.path} -> ${mobilePath}`);
      next({
        path: mobilePath,
        query: to.query,
        replace: true,
      });
      return;
    }
  }

  // 3. PC 设备访问移动端 H5 页面，重定向到 PC 页面
  if (!mobile && isMobilePath) {
    const pcPath = mobileToPcPathMap[to.path] || "/";
    console.log(`PC端重定向: ${to.path} -> ${pcPath}`);
    next({
      path: pcPath,
      query: to.query,
      replace: true,
    });
    return;
  }

  next();
});

export default router;
